import { getTagColorClassName } from '@/components/shared/tag-colors';
import type { BackofficeTagChip } from '../types';

export interface BackofficeTagChipsProps {
  tags: BackofficeTagChip[];
}

export function BackofficeTagChips({ tags }: BackofficeTagChipsProps) {
  if (tags.length === 0) {
    return <span className="text-small text-neutral-500">No tags</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {tags.map((tag) => (
        <span
          key={tag.id}
          className={[
            'inline-flex rounded-full border px-2 py-1 text-small font-medium',
            getTagColorClassName(tag.color),
          ].join(' ')}
        >
          {tag.name}
          {tag.status === 'archived' ? ' (archived)' : ''}
        </span>
      ))}
    </div>
  );
}
